import S from "./bubbling.module.less";
import {memo} from "react";

export const Bubbling = memo(({text, nextPage, compact = false})=>{
   return <div className={`${S.bubbling} ${compact ? S.bubblingCompact : ''}`}>
       <button className={S.bubblingBtn} onClick={nextPage}>
           {text}
       </button>
   </div>
});
